var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98265 5.5V3.5C4.98265 3.10218 5.14251 2.72064 5.42707 2.43934C5.71163 2.15804 6.09757 2 6.5 2C6.90243 2 7.28837 2.15804 7.57293 2.43934C7.85748 2.72064 8.01735 3.10218 8.01735 3.5V5.5M9.5347 4.5L9.9985 10.4615C10.0039 10.5302 9.99481 10.5993 9.9719 10.6643C9.949 10.7294 9.91273 10.7891 9.86538 10.8397C9.81803 10.8902 9.76062 10.9306 9.69675 10.9582C9.63288 10.9858 9.56393 11 9.49423 11H3.50577C3.43607 11 3.36712 10.9858 3.30325 10.9582C3.23938 10.9306 3.18197 10.8902 3.13462 10.8397C3.08727 10.7891 3.051 10.7294 3.0281 10.6643C3.00519 10.5993 2.99613 10.5302 3.0015 10.4615L3.4653 4.5H9.5347Z",
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.19979c84840d788018cdf4ee0416454c.svg";
export { ForwardRef as ReactComponent };